import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path fill-rule="evenodd" clip-rule="evenodd" d="M18.5 5.3a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0m.75-2.25a2.25 2.25 0 0 0-1.542 3.889l-3.205 7.325a2.24 2.24 0 0 0-1.387.292l-1.922-1.923a2.25 2.25 0 1 0-3.722.246l-1.875 3.75A2.253 2.253 0 0 0 2.75 18.8a2.25 2.25 0 1 0 4.088-1.299l1.904-3.809a2.26 2.26 0 0 0 1.303-.086l2.1 2.1a2.25 2.25 0 1 0 3.709-.784l3.227-7.378q.084.006.169.006a2.25 2.25 0 0 0 0-4.5m-5 12.7a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M5 18.05a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m4.25-7.3a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" fill="currentColor"/>' }
  })
);